



























import { Component, Vue, Prop } from 'vue-property-decorator';
import FilterBase, { FilterItem } from '@/components/filters/FilterBase.vue';
import { QuestionFilters } from '@/views/Subject.vue';
import Divider from '@/components/common/Divider.vue';

@Component({
  components: {
    FilterBase,
    Divider,
  },
})
export default class FilterCommon extends Vue {
  @Prop()
  localFilters!: QuestionFilters;

  @Prop({ default: [] })
  availableLanguages!: string[];

  languages: FilterItem[] = [
    { id: 'english', value: 'English', isChecked: false, isDisabled: false },
    {
      id: 'malay',
      value: 'Bahasa Melayu',
      isChecked: false,
      isDisabled: false,
    },
  ];

  difficulties = [
    { id: '1', value: 'Easy', isChecked: false },
    { id: '2', value: 'Medium', isChecked: false },
    { id: '3', value: 'Hard', isChecked: false },
  ];

  sortBys = [
    { id: 'chapter-asc', value: 'Chapter ascending', isChecked: false },
    { id: 'chapter-desc', value: 'Chapter descending', isChecked: false },
    { id: 'difficulty-asc', value: 'Difficulty ascending', isChecked: false },
    { id: 'difficulty-desc', value: 'Difficulty descending', isChecked: false },
  ];

  created() {
    this.languages = this.languages.map(language => {
      language.isChecked = this.localFilters.languages.find(
        initialLanguage => initialLanguage === language.id,
      )
        ? true
        : false;

      if (!this.availableLanguages.includes(language.id)) {
        language.isDisabled = true;
      }
      return language;
    });

    this.sortBys = this.sortBys.map(sortBy => {
      if (sortBy.id === this.localFilters.sortBy) {
        sortBy.isChecked = true;
      }
      return sortBy;
    });

    this.difficulties = this.difficulties.map(difficulty => {
      difficulty.isChecked = this.localFilters.difficulties.find(
        initialDifficulty => initialDifficulty === difficulty.id,
      )
        ? true
        : false;

      return difficulty;
    });
  }

  languangesChanged(filter: { name: string; items: FilterItem[] }) {
    this.languages = filter.items;

    const languages = this.languages
      .filter(languange => languange.isChecked === true)
      .map(languange => {
        return languange.id;
      });

    this.localFilters.languages = languages;
  }

  difficultiesChanged(filter: { name: string; items: FilterItem[] }) {
    this.difficulties = filter.items;

    const difficulties = this.difficulties
      .filter(difficulty => difficulty.isChecked === true)
      .map(difficulty => {
        return difficulty.id;
      });

    this.localFilters.difficulties = difficulties;
  }

  sortBysChanged(filter: { name: string; items: FilterItem[] }) {
    this.sortBys = filter.items;

    const sortBy = this.sortBys.filter(sortBy => sortBy.isChecked === true)[0];

    this.localFilters.sortBy = sortBy.id;
  }
}
